import React, { useState, useEffect } from "react";
import { getCookie } from "../common/Common";
import Config from "config";
import { FloatingCompareButton } from "../Compare/FloatingCompareButton";
import { setLikeProperty } from "../common/Common";

const pagesLink = Config.pagesLink;

const $ = window.$;

export const LoginFooter = (props) => {
  const [likeCount, setLikeCount] = useState(0);

  if (props.favoritePropertyValue === undefined) {
    useEffect(() => {
      setInterval(() => {
        var count = getCookie("favoriteProperty")
          .split(",")
          .filter((x) => x).length;
        if (count != likeCount) {
          setLikeCount(count);
        }
      }, 1000);
    }, []);
  }

  function favClick() {
    if (props.favClick) {
      props.favClick();
    } else {
      goToUrl("/th/propertyforsale/pages/favorite.aspx");
      // goToUrl(pagesLink.search + "?Tab=favoriteProperty");
    }
  }

  function loginClick() {
    goToUrl(pagesLink.login);
  }

  function recentlyClick() {
    if (props.recentlyClick) {
      props.recentlyClick();
    } else {
      goToUrl(pagesLink.search + "?Tab=recentlyviewedProperty");
    }
  }

  function goToUrl(url) {
    window.open(url, "_self");
  }

  window.setLikeProperty = tempFunction;

  function tempFunction(a, b) {
    setLikeProperty(a, b);
  }

  return (
    <>
      <InfoFooter />
      {props.favoritePropertyValue !== undefined ? (
        <div className="bar-footer">
          <div className="containner-bar">
            {/* <div className="item-bar" onClick={favClick}>
              <i className="ic-npa ic-npa-icon-like"></i>
              {props.favoritePropertyValue.split(",").filter((x) => x).length !== 0 && (
                <span className="number-noti show-mobile">
                  {props.favoritePropertyValue.split(",").filter((x) => x).length}
                </span>
              )}
              <span className="text-bar">ทรัพย์ถูกใจ</span>
              {props.favoritePropertyValue.split(",").filter((x) => x).length !== 0 && (
                <span className="number-noti hide-mobile">
                  {props.favoritePropertyValue.split(",").filter((x) => x).length}
                </span>
              )}
            </div>
            <div className="item-bar" onClick={loginClick}>
              <i className="ic-npa ic-npa-icon-settingmatching"></i>
              <span className="text-bar">ตั้งค่าทรัพย์ตรงใจ</span>
            </div>
            <div className="item-bar" onClick={recentlyClick}>
              <i className="ic-npa ic-npa-icon-lastviewed"></i>
              <span className="text-bar">ดูล่าสุด</span>
            </div> */}
            <a href={pagesLink.home} className="item-bar"
            data-kbct="link_click" data-kblb="homepage" data-kbgp="contact">
              <div>
                <i className="ic-npa ic-npa ic-npa-icon-propertyall" />
                <span className="text-bar">หน้าหลัก</span>
              </div>
            </a>
            <a href="javascript:void(0)" onClick={favClick} className="item-bar"
            data-kbct="click" data-kblb="favorite" data-kbgp="contact">
              <div>
                <i className="ic-npa ic-npa-icon-like" />
                {props.favoritePropertyValue.split(",").filter((x) => x).length !== 0 && (
                  <span className="number-noti show-mobile">
                    {props.favoritePropertyValue.split(",").filter((x) => x).length}
                  </span>
                )}
                <span className="text-bar">ทรัพย์ถูกใจ</span>
                {props.favoritePropertyValue.split(",").filter((x) => x).length !== 0 && (
                  <span className="number-noti hide-mobile">
                    {props.favoritePropertyValue.split(",").filter((x) => x).length}
                  </span>
                )}
              </div>
            </a>
            <a href={pagesLink.promotion} className="item-bar"
            data-kbct="link_click" data-kblb="promotion" data-kbgp="contact">
              <div>
                <i className="ic-npa ic-npa-icon-promotion" />
                <span className="text-bar">โปรโมชัน</span>
              </div>
            </a>
          </div>
        </div>
      ) : (
        <div className="bar-footer">
          <div className="containner-bar">
            <a href={pagesLink.home} className="item-bar"
            data-kbct="link_click" data-kblb="homepage" data-kbgp="contact">
              <div>
                <i className="ic-npa ic-npa ic-npa-icon-propertyall" />
                <span className="text-bar">หน้าหลัก</span>
              </div>
            </a>
            <a href="javascript:void(0)" onClick={favClick} className="item-bar"
            data-kbct="click" data-kblb="favorite" data-kbgp="contact">
              <div>
                <i className="ic-npa ic-npa-icon-like" />
                {likeCount !== 0 && <span className="number-noti show-mobile">{likeCount}</span>}
                <span className="text-bar">ทรัพย์ถูกใจ</span>
                {likeCount !== 0 && <span className="number-noti hide-mobile">{likeCount}</span>}
              </div>
            </a>
            <a href={pagesLink.promotion} className="item-bar"
            data-kbct="link_click" data-kblb="promotion" data-kbgp="contact">
              <div>
                <i className="ic-npa ic-npa-icon-promotion" />
                <span className="text-bar">โปรโมชัน</span>
              </div>
            </a>
            {/* <div className="item-bar" onClick={loginClick}>
              <i className="ic-npa ic-npa-icon-settingmatching"></i>
              <span className="text-bar">ตั้งค่าทรัพย์ตรงใจ</span>
            </div>
            <div className="item-bar" onClick={favClick}>
              <i className="ic-npa ic-npa-icon-like"></i>
              {likeCount !== 0 && <span className="number-noti show-mobile">{likeCount}</span>}
              <span className="text-bar">ทรัพย์ถูกใจ</span>
              {likeCount !== 0 && <span className="number-noti hide-mobile">{likeCount}</span>}
            </div>
            <div className="item-bar" onClick={recentlyClick}>
              <i className="ic-npa ic-npa-icon-lastviewed"></i>
              <span className="text-bar">ดูล่าสุด</span>
            </div> */}
          </div>
        </div>
      )}
      <FloatingCompareButton />
    </>
  );
};

const InfoFooter = () => {
  const PropertyforsaleLinkComponent = () => {
    return (
      <a href="/th/propertyforsale/list/pages/house.aspx"
         className="link"
         title="บ้านมือสอง">
        บ้านมือสอง
      </a>
    );
  };

  const HouseLinkComponent = () => {
    return (
      <a
        href="/th/propertyforsale/list/pages/house.aspx"
        className="link"
        title="บ้านเดี่ยว"
      >
        บ้านเดี่ยว
      </a>
    );
  };
  const TownhouseLinkComponent = () => {
    return (
      <a
        href="/th/propertyforsale/list/pages/townhouse.aspx"
        className="link"
        title="ทาวน์เฮ้าส์"
      >
        ทาวน์เฮ้าส์
      </a>
    );
  };
  const CondominiumLinkComponent = () => {
    return (
      <a
        href="/th/propertyforsale/list/pages/condominium.aspx"
        className="link"
        title="คอนโดมิเนียม"
      >
        คอนโดมิเนียม
      </a>
    );
  };
  const CommercialBuildingLinkComponent = () => {
    return (
      <a
        href="/th/propertyforsale/list/pages/commercial-building.aspx"
        className="link"
        title="อาคารพาณิชย์"
      >
        อาคารพาณิชย์
      </a>
    );
  };
  const LandLinkComponent = () => {
    return (
      <a
        href="/th/propertyforsale/list/pages/land.aspx"
        className="link"
        title="ที่ดิน"
      >
        ที่ดิน
      </a>
    );
  };

  const AllLinkComponent = (props) => {
    return (
      <>
        {props.showHomePage && <PropertyforsaleLinkComponent />} <HouseLinkComponent />{" "}
        <TownhouseLinkComponent /> <CondominiumLinkComponent /> <CommercialBuildingLinkComponent />{" "}
        และ <LandLinkComponent />{" "}
      </>
    );
  };
  if (window.location.pathname.indexOf("/th/propertyforsale/search") != -1) {
    return (
      <section className="intro-footer">
        <div className="container">
          <h2 className="intro-footer-title">ค้นหาทรัพย์ขายทอดตลาด บ้านหลุดจำนองราคาพิเศษ</h2>
          <p>
            ค้นหาทรัพย์ที่ถูกใจได้ง่ายๆ ทรัพย์รอการขายกสิกรไทยที่คัดสรรทรัพย์ขายทอดตลาดจากทั่วประเทศ
            คัด คุ้ม ครบ เช่น <AllLinkComponent showHomePage={true} />
            เพื่อตอบโจทย์ทุกความต้องการของคุณ
          </p>
        </div>
      </section>
    );
  } else if (window.location.pathname.indexOf("/th/propertyforsale/promotion") != -1) {
    return (
      <section className="intro-footer">
        <div className="container">
          <h2 className="intro-footer-title">โปรโมชันทรัพย์สินรอการขาย ธนาคารกสิกรไทย</h2>
          <p>
            เลือกหาทรัพย์ที่ถูกใจ ในราคาพิเศษแบบ คัด คุ้ม ครบ กับโปรโมชันทรัพย์สินรอการขายจาก
            ธนาคารกสิกรไทย เช่น <AllLinkComponent showHomePage={true} />
            เพื่อตอบโจทย์ทุกความต้องการของคุณ
          </p>
        </div>
      </section>
    );
  }
  return (
    <section className="intro-footer">
      {/* <div className="container"> */}
      <h2 className="intro-footer-title">ทรัพย์สินรอการขาย ทรัพย์ธนาคารกสิกรไทย</h2>
      <p>
        รวมทรัพย์รอการขายยอดนิยม ทรัพย์ธนาคารราคาพิเศษ เช่น <AllLinkComponent showHomePage={true} />
        จากทั่วประเทศ คัดสรรบ้านมือสองตอบโจทย์ทุกความต้องการ ไม่ว่าจะเพื่ออยู่อาศัยหรือการลงทุน
      </p>
      {/* </div> */}
    </section>
  );
};
